import { render, staticRenderFns } from "./OnboardingForm.vue?vue&type=template&id=16886a8d&"
import script from "./OnboardingForm.vue?vue&type=script&lang=js&"
export * from "./OnboardingForm.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingForm.vue?vue&type=style&index=0&id=16886a8d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports